import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { SignInPage } from '@/features/auth/signin-page';
import { bootSession } from '@/lib/auth/session';
import { safeReturnPath } from '@/lib/auth/pkce';

const searchSchema = z.object({
  return_to: z.string().optional(),
  error: z.string().optional(),
});

export const Route = createFileRoute('/signin')({
  validateSearch: searchSchema,
  beforeLoad: async ({ search }) => {
    const session = await bootSession();
    // Already signed in (or working from a cached session): go straight in.
    if (session.status === 'active') {
      throw redirect({ href: safeReturnPath(search.return_to), replace: true });
    }
  },
  component: SignInPage,
});
